import { render, staticRenderFns } from "./DangerConfirmModal.vue?vue&type=template&id=0a3e6324&scoped=true"
import script from "./DangerConfirmModal.vue?vue&type=script&lang=js"
export * from "./DangerConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./DangerConfirmModal.vue?vue&type=style&index=0&id=0a3e6324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e6324",
  null
  
)

export default component.exports